import React, { useRef } from "react";
import Modal from "@/components/Modal";
import CategoryTree from "@/containers/GroupsDevices/Category/CategoryTreeWrapper";
import { useTranslation } from "@/langs/useTranslation";
import { toast } from "@/apis/request";

function GroupDevicesModal({
  open,
  onConfirm,
  onClose,
  checkedKeys,
  checkStrictly = false,
  groupCheckable = false,
  disableRoot,
  dontCheck
}) {
  const { t } = useTranslation();
  const checked = useRef(checkedKeys);
  const checkedNodes = useRef([]);
  const tree = useRef(null);

  checked.current = checkedKeys;

  const handleConfirm = () => {
    if (!dontCheck && !checked.current.length) {
      toast.info(t({ defaultMessage: "请选择一个设备" }));
      return;
    }
    if (checked.current.length > 0 && checkedNodes.current.length === 0) {
      checkedNodes.current = checked.current.map(id => ({
        key: id,
        id,
        isLeaf: true
      }));
    }
    return onConfirm?.(checked.current, checkedNodes.current);
  };

  const handleCheck = (checkedKeys, info) => {
    checked.current = checkedKeys;
    checkedNodes.current = info.checkedNodes;
  };

  return (
    <Modal
      title={t({ defaultMessage: "选择设备" })}
      width={576}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <CategoryTree
        ref={tree}
        showAll={false}
        showSwitch={false}
        collapse={false}
        selectable={false}
        groupCheckable={groupCheckable}
        disableRoot={disableRoot}
        checkedKeys={checkedKeys}
        checkStrictly={checkStrictly}
        searchPlaceholder={t({ defaultMessage: "搜索设备" })}
        height={550}
        deviceMode
        readOnly
        checkable
        onCheck={handleCheck}
      />
    </Modal>
  );
}

const isEqual = (prevProps, nextProps) => {
  if (nextProps.open) {
    return false;
  }
  return nextProps.open === prevProps.open;
};

export default React.memo(GroupDevicesModal, isEqual);
